<template>
  <div style="background:#fff;height:100vh">
    <Top />
    <div class="main_wqx" style="text-align: center">
      <img
        src="../assets/imgs/wqx.jpg"
        style=" margin:auto 0;text-align: center;display: inline-block;width: 1100px;"
      />
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
export default {
  components: {
    Top,
    Footer
  },
  data() {
    return {};
  }
};
</script>

<style  lang='less' scoped>
/deep/.guides {
  display: none !important;
}
</style>